module.exports = __webpack_public_path__ + "static/media/bringKittenHome.cb52ad78.jpg";